import { Component, forwardRef, OnInit } from '@angular/core';
import { InventoryActionCreateFormComponent } from '../inventory-action-create-form.component';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { FormGroupPipe } from '../../../../../shared/pipes/form-group.pipe';
import { InventoryActionFormComponent } from '../../../../../shared/common-forms/inventory-action-form/inventory-action-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AsyncPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-loss-create-form',
    templateUrl: './loss-create-form.component.html',
    styleUrls: ['../inventory-action-create-form.component.scss'],
    imports: [
      AsyncPipe,
      FormGroupPipe,
      forwardRef(() => InventoryActionFormComponent),
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      MatToolbarModule,
      ReactiveFormsModule,
    ]
})
export class LossCreateFormComponent extends InventoryActionCreateFormComponent implements OnInit {
  form = this.fb.group({
    inventory_action_products: this.fb.array([]),
    warehouse_id: [null, [Validators.required]],
    draft: [false],
  });
}
